import React from 'react';

const SignUp = () => {
  const handleSignUpClick = () => {
    const userType = 'NO_HOST';
    const url = `https://www.hightable.ai/tables-curated-just-for-you?user_type=${userType}`;
    window.location.href = url;
  };

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={(e) => {
        e.preventDefault();
        handleSignUpClick();
      }}
      data-w-id="00369884-f0d3-afd3-1a3a-f3e33bafde3b"
      className="su-button mob-menu w-inline-block"
    >
      <div>SIGNUP</div>
    </div>
  );
};

export default SignUp;
